interface HomeworkTraceStepLink {
  readonly stepIndex: number;
  readonly parentStepIndex: number | null;
}

export function nextHomeworkTraceSteps<T extends HomeworkTraceStepLink>(
  steps: readonly T[],
  currentStepIndex: number | null,
): readonly T[] {
  return steps.filter((step) => step.parentStepIndex === currentStepIndex);
}

export function homeworkTracePathToStep(
  steps: readonly HomeworkTraceStepLink[],
  targetStepIndex: number | null,
): readonly number[] {
  if (targetStepIndex === null) return [];
  const reversed: number[] = [];
  let current = steps[targetStepIndex];
  while (current !== undefined) {
    reversed.push(current.stepIndex);
    current = current.parentStepIndex === null ? undefined : steps[current.parentStepIndex];
  }
  return reversed.reverse();
}

export function selectHomeworkTraceStep(
  steps: readonly HomeworkTraceStepLink[],
  path: readonly number[],
  cursor: number,
  selectedStepIndex: number,
): Readonly<{ path: readonly number[]; cursor: number }> | null {
  const selected = steps[selectedStepIndex];
  const currentStepIndex = cursor === 0 ? null : (path[cursor - 1] ?? null);
  if (selected === undefined || selected.parentStepIndex !== currentStepIndex) return null;

  const prefix = path.slice(0, cursor);
  const continuation = [selected.stepIndex];
  let tail = selected.stepIndex;
  while (true) {
    const child = steps.find((step) => step.parentStepIndex === tail);
    if (child === undefined) break;
    continuation.push(child.stepIndex);
    tail = child.stepIndex;
  }
  return Object.freeze({
    path: Object.freeze([...prefix, ...continuation]),
    cursor: prefix.length + 1,
  });
}
